"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_CyndinesSoulHarvest_OnTickEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
let Ability_CyndinesSoulHarvest_OnTickEventHandlerScript = class Ability_CyndinesSoulHarvest_OnTickEventHandlerScript {
    run(sequence, container, handler, event) {
        const summons = container.getSummonedCompanions(event.subject);
        if (summons.length === 0) {
            return;
        }
        const amount = container.getPercentOfBaseHealth(event.subject, 3);
        container.applyHealing({
            sequence,
            healerId: event.subject,
            targetId: event.subject,
            amount,
            attributePercent: 0,
        });
    }
};
Ability_CyndinesSoulHarvest_OnTickEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_CyndinesSoulHarvest_OnTick")
], Ability_CyndinesSoulHarvest_OnTickEventHandlerScript);
exports.Ability_CyndinesSoulHarvest_OnTickEventHandlerScript = Ability_CyndinesSoulHarvest_OnTickEventHandlerScript;
